import axios from "axios";
import { isQueueable, enqueue } from "./pwa";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // çevrimdışıyken iş güncellemesi: kuyruğa al, arayüze "bekliyor" olarak başarılı dön
    if (!err.response && !err.config?.__noQueue && isQueueable(err.config) && localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role === "technician") {
      enqueue(err.config);
      return Promise.resolve({ data: { queued: true, ...JSON.parse(err.config.data) }, status: 202, config: err.config, headers: {}, statusText: "Queued" });
    }
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_LABELS = {
  yeni: { label: "Yeni", color: "bg-blue-100 text-blue-800 border-blue-200" },
  atandi: { label: "Atandı", color: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  yolda: { label: "Yolda", color: "bg-amber-100 text-amber-800 border-amber-200" },
  basladi: { label: "Başladı", color: "bg-orange-100 text-orange-800 border-orange-200" },
  tamamlandi: { label: "Tamamlandı", color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  faturalandi: { label: "Faturalandı", color: "bg-teal-100 text-teal-800 border-teal-200" },
  iptal: { label: "İptal", color: "bg-rose-100 text-rose-800 border-rose-200" },
};

export const PRIORITY_LABELS = {
  dusuk: { label: "Düşük", color: "bg-slate-100 text-slate-700" },
  normal: { label: "Normal", color: "bg-blue-100 text-blue-700" },
  yuksek: { label: "Yüksek", color: "bg-amber-100 text-amber-800" },
  acil: { label: "ACİL", color: "bg-red-100 text-red-800" },
};

export function formatTL(amount) {
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(amount || 0);
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
